import { render } from "./SharedTransactionPdfView.vue?vue&type=template&id=207fb6ae&scoped=true"
import script from "./SharedTransactionPdfView.vue?vue&type=script&lang=js"
export * from "./SharedTransactionPdfView.vue?vue&type=script&lang=js"

import "./SharedTransactionPdfView.vue?vue&type=style&index=0&id=207fb6ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207fb6ae"]])

export default __exports__